/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacySaleCreditPaymentTracker from './pharmacy-sale-credit-payment-tracker';
import PharmacySaleCreditPaymentTrackerDetail from './pharmacy-sale-credit-payment-tracker-detail';
import PharmacySaleCreditPaymentTrackerUpdate from './pharmacy-sale-credit-payment-tracker-update';
import PharmacySaleCreditPaymentTrackerDeleteDialog from './pharmacy-sale-credit-payment-tracker-delete-dialog';

const PharmacySaleCreditPaymentTrackerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacySaleCreditPaymentTracker />} />
    <Route path="new" element={<PharmacySaleCreditPaymentTrackerUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacySaleCreditPaymentTrackerDetail />} />
      <Route path="edit" element={<PharmacySaleCreditPaymentTrackerUpdate />} />
      <Route path="delete" element={<PharmacySaleCreditPaymentTrackerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacySaleCreditPaymentTrackerRoutes;
